




















































import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import OperatorTip from '@/components/OperatorTip.vue';
import GroupCard from '@/components/GroupCard.vue';
import OperatorChoice from '@/components/OperatorChoice.vue';
import { OperatorModel, unchoicedOperator } from '@/models/Operator';
import { GroupModel } from '@/models/Group';

const module = namespace('GroupStore');

@Component({
  components: {
    OperatorTip,
    GroupCard,
    OperatorChoice,
  },
})
export default class Recruiting extends Vue {
    @module.State private drawedGroup!: GroupModel;
    @module.State private choicedOperators!: OperatorModel[];

    @module.Action('drawGroup') private drawGroup!: () => void;

    private started: any;
    private running!: boolean;

    private totalCost: number = 40;

    private showChoicer: boolean = false;
    private choiceOperatorIdx: number = 0;

    protected created() {
        this.started = null;
        this.running = false;
    }

    private clickDraw() {
        if (this.running === false) {
            this.running = true;
            this.started = setInterval(this.drawing, 10);
        } else {
            this.running = false;
            clearInterval(this.started);
        }
    }

    private drawing() {
        this.drawGroup();
    }

    get currentCost(): number {
        return this.choicedOperators.reduce((sum, operator) => { return sum + operator.recruitCost; }, 0);
    }

    get remainingCost(): number {
        return this.totalCost - this.currentCost;
    }

    get getClassByRemainingCost() {
        if (this.remainingCost <= 0) {
            return 'cost-error';
        } else if (this.totalCost / 2 >= this.remainingCost) {
            return 'cost-warning';
        }
        return '';
    }

    private startChoiceOperator(targetIdx: number) {
        this.choiceOperatorIdx = targetIdx;
        this.showChoicer = true;
    }

    private closeChoicer() {
        this.showChoicer = false;
    }

    private operatorChoiced(targetIdx: number, choiced: OperatorModel) {
        this.$set(this.choicedOperators, targetIdx, choiced);
        this.showChoicer = false;
    }

    private resetChoiced() {
        this.choicedOperators.map((operator, idx) => this.$set(this.choicedOperators, idx, unchoicedOperator));
    }
}
